import { createSlice } from "@reduxjs/toolkit";
import {
  getTeacherGroups,
  getTeacherSchedule,
  getJournalOptions,
  getJournalDates,
  getJournalStudents,
  getMarkTypes,
  makeJournalMark,
  deleteJournalMark,
  makeJournalAssignmentData,
  getStudentsAttendance,
  getStudentDiary,
  getGroupSubjects,
  getStudentsRating,
  getAbsentTypes,
  makeJournalSemesterMark,
  deleteJournalSemesterMark,
  getDiarySignatures,
  getSignaturesBehaviorTypes,
  getParentActivity,
  getCuratorLetters,
} from "./api";
import {
  getGroupSchedule,
  getGroupStudents,
  getGroupSemesterDatas,
} from "pages/admin/api";
import { roles } from "constants/variables";

const initialState = {
  teacherGroups: null,
  groupsLinks: null,
  teacherSchedule: null,
  groupdSchedule: null,
  journalOptions: null,
  activeClassRoom: null,
  selectedSubject: null,
  journalSelectedSemester: null,
  journalDates: null,
  journalStudents: null,
  scrollLeft: 0,
  scrollTop: 0,
  markTypes: null,
  studentAttendance: null,
  groupStudents: null,
  studentDiary: null,
  groupSubjects: null,
  groupSemesterData: null,
  studentsRating: null,
  absentTypes: null,
  diarySignatures: null,
  behaviorTypes: null,
  parentActivity: null,
  letters: null,
};

const teacherSlice = createSlice({
  name: "teacher",
  initialState,
  reducers: {
    setActiveClassRoom(state, action) {
      state.activeClassRoom = action.payload;
    },
    setSelectedSubject(state, action) {
      state.selectedSubject = action.payload;
    },
    setJournalSelecetdSemester(state, action) {
      state.journalSelectedSemester = action.payload;
    },
    scrollLeftAC(state, action) {
      state.scrollLeft = action.payload;
    },
    scrollTopAC(state, action) {
      state.scrollTop = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTeacherGroups.fulfilled, (state, action) => {
      state.teacherGroups = action.payload;
      const role = sessionStorage.getItem("userRole");

      const currentUser = roles[role];
      state.groupsLinks = action.payload?.map((el, i) => {
        const id = currentUser?.key === "groupHead" ? i + 1 : 2 + i;
        return {
          id,
          selectId: id,
          name: `Ҷадвали дарсии гуруҳи ${el?.number}`,
          link: `/myGroupSchedule/${el?.id}`,
        };
      });
    });

    builder.addCase(getTeacherSchedule.fulfilled, (state, action) => {
      state.teacherSchedule = action.payload;
    });

    builder.addCase(getGroupSchedule.fulfilled, (state, action) => {
      state.groupdSchedule = action.payload;
    });

    builder.addCase(getJournalOptions.fulfilled, (state, action) => {
      state.journalOptions = action.payload;
      state.activeClassRoom = action?.payload?.[0];
    });

    builder.addCase(getJournalDates.fulfilled, (state, action) => {
      state.journalDates = action.payload;
    });

    builder.addCase(getJournalStudents.fulfilled, (state, action) => {
      state.journalStudents = action.payload;
    });

    builder.addCase(getMarkTypes.fulfilled, (state, action) => {
      state.markTypes = action.payload;
    });

    builder.addCase(makeJournalMark.fulfilled, (state, action) => {
      const { status, ...rest } = action.payload;
      const id = action.meta?.arg?.group_stud_id;
      if (action.payload?.status === 0) {
        state.journalStudents = state.journalStudents?.map((el) => {
          if (el?.group_student_id === id) {
            return { ...el, marks: [...el.marks, rest] };
          }
          return el;
        });
      }
    });

    builder.addCase(makeJournalSemesterMark.fulfilled, (state, action) => {
      const { status, ...rest } = action.payload;
      const id = action.payload?.group_student_id;
      if (action.payload?.status === 0) {
        state.journalStudents = state.journalStudents?.map((el) => {
          if (el?.group_student_id === id) {
            return { ...el, semester_mark: rest };
          }
          return el;
        });
      }
    });

    builder.addCase(deleteJournalSemesterMark.fulfilled, (state, action) => {
      const id = action.meta?.arg?.group_student_id;

      state.journalStudents = state.journalStudents?.map((el) => {
        if (el?.group_student_id === id) {
          return {
            ...el,
            semester_mark: null,
          };
        }
        return el;
      });
    });

    builder.addCase(deleteJournalMark.fulfilled, (state, action) => {
      const id = action.meta?.arg?.group_stud_id;
      const removeMark = action.meta?.arg?.mark_id;

      state.journalStudents = state.journalStudents?.map((el) => {
        if (el?.group_student_id === id) {
          return {
            ...el,
            marks: el.marks?.filter(
              (el) => el.student_assignment_mark_id !== removeMark
            ),
          };
        }
        return el;
      });
    });

    builder.addCase(makeJournalAssignmentData.fulfilled, (state, action) => {
      const id = action.meta?.arg?.schedule_date_id;

      state.journalDates = {
        ...state.journalDates,
        dates: state.journalDates?.dates?.map((el) => {
          if (el.schedule_date_id === id) {
            return { ...el, ...action.payload };
          }
          return el;
        }),
      };
    });

    builder.addCase(getStudentsAttendance.fulfilled, (state, action) => {
      state.studentAttendance = action.payload;
    });

    builder.addCase(getGroupStudents.fulfilled, (state, action) => {
      state.groupStudents = action.payload;
    });

    builder.addCase(getStudentDiary.fulfilled, (state, action) => {
      state.studentDiary = action.payload;
    });

    builder.addCase(getGroupSubjects.fulfilled, (state, action) => {
      state.groupSubjects = action.payload;
    });

    builder.addCase(getGroupSemesterDatas.fulfilled, (state, action) => {
      state.groupSemesterData = action.payload;
    });

    builder.addCase(getStudentsRating.fulfilled, (state, action) => {
      state.studentsRating = action.payload;
    });

    builder.addCase(getAbsentTypes.fulfilled, (state, action) => {
      state.absentTypes = action.payload;
    });

    builder.addCase(getDiarySignatures.fulfilled, (state, action) => {
      state.diarySignatures = action.payload;
    });

    builder.addCase(getSignaturesBehaviorTypes.fulfilled, (state, action) => {
      state.behaviorTypes = action.payload;
    });

    builder.addCase(getParentActivity.fulfilled, (state, action) => {
      state.parentActivity = action.payload;
    });

    builder.addCase(getCuratorLetters.fulfilled, (state, action) => {
      state.letters = action.payload;
    });
  },
});

export const {
  setActiveClassRoom,
  setSelectedSubject,
  setJournalSelecetdSemester,
  scrollLeftAC,
  scrollTopAC,
} = teacherSlice.actions;

export default teacherSlice.reducer;
